import { history } from "../_helpers";

export const connectionsServices = {
  getAllConnections,
  getTopCardConnections,
  fetchActiveSourceAndDestination,
  addConnection,
  getConnectionById,
  getConnectionByWorkspaceId,
  getEndpointsByConnectionId,
  connfiqureConnectionById,
  editConnectionById,
  getSlackListIntegration,
  getBitbucketIntegration,
  searchConnections,
  getConnectionsFilters,
  applyConnectionsFilters,
  activateConnection,
};

function getAllConnections(offset = 0, limit = 10) {
  let user = JSON.parse(localStorage.getItem("user"));
  const requestOptions = {
    method: "GET",
    headers: {
      "x-access-token": user.accessToken,
    },
  };

  return fetch(
    `${process.env.REACT_APP_BACKEND_API_URL}/api/v1/connections/${offset}/${limit}`,
    requestOptions
  ).then(handleResponse);
}

function getTopCardConnections() {
  let user = JSON.parse(localStorage.getItem("user"));
  const requestOptions = {
    method: "GET",
    headers: {
      "x-access-token": user.accessToken,
    },
  };

  return fetch(
    `${process.env.REACT_APP_BACKEND_API_URL}/api/v1/connections/topCards`,
    requestOptions
  ).then(handleResponse);
}

function fetchActiveSourceAndDestination() {
  let user = JSON.parse(localStorage.getItem("user"));
  const requestOptions = {
    method: "GET",
    headers: {
      "x-access-token": user.accessToken,
    },
  };

  return fetch(
    `${process.env.REACT_APP_BACKEND_API_URL}/api/v1/active/source/destination`,
    requestOptions
  ).then(handleResponse);
}

function addConnection(formData) {
  let user = JSON.parse(localStorage.getItem("user"));
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "x-access-token": user.accessToken,
    },
    body: JSON.stringify(formData),
  };
  return fetch(
    `${process.env.REACT_APP_BACKEND_API_URL}/api/v1/connections`,
    requestOptions
  ).then(handleResponse);
}

function getConnectionById(connectionId) {
  let user = JSON.parse(localStorage.getItem("user"));
  const requestOptions = {
    method: "GET",
    headers: {
      "x-access-token": user.accessToken,
    },
  };

  return fetch(
    `${process.env.REACT_APP_BACKEND_API_URL}/api/v1/connection/${connectionId}`,
    requestOptions
  ).then(handleResponse);
}

function getConnectionByWorkspaceId(workspaceId) {
  let user = JSON.parse(localStorage.getItem("user"));
  const requestOptions = {
    method: "GET",
    headers: {
      "x-access-token": user.accessToken,
    },
  };

  return fetch(
    `${process.env.REACT_APP_BACKEND_API_URL}/api/v1/connection/workspace/${workspaceId}`,
    requestOptions
  ).then(handleResponse);
}

function getEndpointsByConnectionId(connectionId) {
  let user = JSON.parse(localStorage.getItem("user"));
  const requestOptions = {
    method: "GET",
    headers: {
      "x-access-token": user.accessToken,
    },
  };

  return fetch(
    `${process.env.REACT_APP_BACKEND_API_URL}/api/v1/connection/${connectionId}/endpoints`,
    requestOptions
  ).then(handleResponse);
}

function connfiqureConnectionById(connectionId, formData) {
  let user = JSON.parse(localStorage.getItem("user"));
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "x-access-token": user.accessToken,
    },
    body: JSON.stringify(formData),
  };

  return fetch(
    `${process.env.REACT_APP_BACKEND_API_URL}/api/v1/connection/${connectionId}/configure`,
    requestOptions
  ).then(handleResponse);
}
function editConnectionById(connectionId, formData) {
  let user = JSON.parse(localStorage.getItem("user"));
  const requestOptions = {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
      "x-access-token": user.accessToken,
    },
    body: JSON.stringify(formData),
  };

  return fetch(
    `${process.env.REACT_APP_BACKEND_API_URL}/api/v1/connection/${connectionId}`,
    requestOptions
  ).then(handleResponse);
}

function getSlackListIntegration() {
  let user = JSON.parse(localStorage.getItem("user"));
  const requestOptions = {
    method: "GET",
    headers: {
      "x-access-token": user.accessToken,
    },
  };
  return fetch(
    `${process.env.REACT_APP_BACKEND_API_URL}/api/v1/connection/slack/integration`,
    requestOptions
  ).then(handleResponse);
}

function getBitbucketIntegration() {
  let user = JSON.parse(localStorage.getItem("user"));
  const requestOptions = {
    method: "GET",
    headers: {
      "x-access-token": user.accessToken,
    },
  };
  return fetch(
    `${process.env.REACT_APP_BACKEND_API_URL}/api/v1/connection/bitbucket/integration`,
    requestOptions
  ).then(handleResponse);
}

function searchConnections(searchText, offset, limit) {
  let user = JSON.parse(localStorage.getItem("user"));
  const requestOptions = {
    method: "GET",
    headers: {
      "x-access-token": user.accessToken,
    },
  };
  return fetch(
    `${process.env.REACT_APP_BACKEND_API_URL}/api/v1/connections/search/${offset}/${limit}?searchText=${searchText}`,
    requestOptions
  ).then(handleResponse);
}

function getConnectionsFilters() {
  let user = JSON.parse(localStorage.getItem("user"));
  const requestOptions = {
    method: "GET",
    headers: {
      "x-access-token": user.accessToken,
    },
  };
  return fetch(
    `${process.env.REACT_APP_BACKEND_API_URL}/api/v1/connections/filters`,
    requestOptions
  ).then(handleResponse);
}

function applyConnectionsFilters(
  destination,
  source,
  user,
  workspace,
  startDate,
  endDate,
  offset = 0,
  limit = 10
) {
  let userData = JSON.parse(localStorage.getItem("user"));
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "x-access-token": userData.accessToken,
    },
    body: JSON.stringify({
      destination,
      source,
      user,
      workspace,
      startDate,
      endDate,
    }),
  };
  return fetch(
    `${process.env.REACT_APP_BACKEND_API_URL}/api/v1/connections/filter/${offset}/${limit}`,
    requestOptions
  ).then(handleResponse);
}

function activateConnection(isActive, connectionId) {
  let user = JSON.parse(localStorage.getItem("user"));
  const requestOptions = {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
      "x-access-token": user.accessToken,
    },
    body: JSON.stringify({ isActive }),
  };
  return fetch(
    `${process.env.REACT_APP_BACKEND_API_URL}/api/v1/connections/activate/${connectionId}`,
    requestOptions
  ).then(handleResponse);
}

function handleResponse(response) {
  return response.text().then((text) => {
    const data = text && JSON.parse(text);
    if (!response.ok) {
      // checking token expiry
      if (
        response.status === 401 &&
        data.message.includes("Invalid JWT token")
      ) {
        // redirecting to signin page
        history.push("/auth/signin");
        // removing local storage token
        localStorage.removeItem("user");
        return;
      }
      const error = (data && data.message) || response.statusText;
      return Promise.reject(error);
    }
    return data;
  });
}
